import { render, staticRenderFns } from "./aedTableLegend.vue?vue&type=template&id=49abb918&scoped=true&"
import script from "./aedTableLegend.vue?vue&type=script&lang=js&"
export * from "./aedTableLegend.vue?vue&type=script&lang=js&"
import style0 from "./aedTableLegend.vue?vue&type=style&index=0&id=49abb918&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49abb918",
  null
  
)

export default component.exports